/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'extension.charts.aggregateData': 'Agregovat data',
  'extension.charts.aggregateDataDescription':
    'V případě, že má více řádků stejnou hodnotu, můžete tyto hodnoty zkombinovat do jediného datového bodu.',
  'extension.charts.category': 'Kategorie',
  'extension.charts.customizeTab': 'Přizpůsobit',
  'extension.charts.dataMissing.details': 'Zdrojovou tabulku tohoto grafu se na stránce nepodařilo najít.',
  'extension.charts.dataMissing.title': 'Žádná data k zobrazení',
  'extension.charts.dataTab': 'Data',
  'extension.charts.defaultColumnName': 'Sloupec {0}',
  'extension.charts.defaultTitle': 'Graf bez názvu',
  'extension.charts.defaultYLabel': 'Osa bez názvu',
  'extension.charts.extensionTitle': 'Graf',
  'extension.charts.height': 'Výška oblasti vykreslení',
  'extension.charts.height.large': 'Vyšší',
  'extension.charts.height.medium': 'Výchozí',
  'extension.charts.height.small': 'Nižší',
  'extension.charts.horizontal.orientation.label': 'Horizontální',
  'extension.charts.insert.tooltip': 'Vložit graf',
  'extension.charts.legend': 'Legenda',
  'extension.charts.legend.auto': 'Automaticky',
  'extension.charts.legend.bottom': 'Dole',
  'extension.charts.legend.left': 'Vlevo',
  'extension.charts.legend.position': 'Umístění legendy',
  'extension.charts.legend.right': 'Vpravo',
  'extension.charts.legend.show': 'Zobrazit legendu',
  'extension.charts.legend.top': 'Nahoře',
  'extension.charts.options.label': 'Možnosti grafu',
  'extension.charts.options.tooltip': 'Změnit možnosti grafu',
  'extension.charts.orientation.label': 'Orientace',
  'extension.charts.seriesNames': 'Datové řady',
  'extension.charts.showPoints': 'Zobrazit datové body',
  'extension.charts.smoothLines': 'Vyhlazené čáry',
  'extension.charts.style': 'Styl',
  'extension.charts.title': 'Název',
  'extension.charts.type.bar': 'Pruhový',
  'extension.charts.type.fieldDescription': 'Typ grafu',
  'extension.charts.type.line': 'Spojnicový',
  'extension.charts.type.pie': 'Výsečový',
  'extension.charts.userTitle': 'Název',
  'extension.charts.vertical.orientation.label': 'Vertikální',
  'extension.charts.xAxis': 'Osa X',
  'extension.charts.xLabel': 'Popisek osy X',
  'extension.charts.yLabel': 'Popisek osy Y',
};
